var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDth5F9878E6E1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.13 12.9l3-3-1.07-1.04-3 3-8.15-8.17a2.6 2.6 0 0 0-2.06-.77A2.67 2.67 0 0 0 4.9 4 15.07 15.07 0 0 0 26 25.08a2.66 2.66 0 0 0 .33-4zm7 11a13.58 13.58 0 0 1-19-19A1.18 1.18 0 0 1 7 4.42h.09a1.07 1.07 0 0 1 .79.33l17.35 17.37a1.14 1.14 0 0 1 .33.89 1.2 1.2 0 0 1-.48.86zm1.46-16.5L28 7a7.08 7.08 0 0 0-5-5l-.39 1.45a5.58 5.58 0 0 1 3.98 3.95zM7.191 10.765l1.061-1.061L20.28 21.732l-1.061 1.061z",
    fill: "#231f20"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.89,
    cy: 8.08,
    r: 2.1,
    fill: "#f27a21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDth5F9878E6E1);
export default __webpack_public_path__ + "static/media/icon_dth_5f9878e6e1.a6c15dd204eae157c3ecaa14ff80cc7e.svg";
export { ForwardRef as ReactComponent };